// A hill road's seed (#195), on its own so a test can feed the seeds
// itself (#216): `Math.random` is also where three.js draws every object's
// UUID from, so seeding it alone ties the road to how much a frame builds.

/** A new run's road seed: any 32-bit number. */
export const randomSeed = (): number => Math.floor(Math.random() * 2 ** 32);
